// @flow

import history from './history';
import routerMiddleware from './routerMiddleware';

export { history, routerMiddleware };



// WEBPACK FOOTER //
// ./src/router/index.js